import { render, staticRenderFns } from "./firstbit.vue?vue&type=template&id=7d5a3f48&"
import script from "./firstbit.vue?vue&type=script&lang=js&"
export * from "./firstbit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports